import { render } from "./space-list.vue?vue&type=template&id=4cb02bd2&scoped=true&ts=true"
import script from "./space-list.vue?vue&type=script&lang=ts"
export * from "./space-list.vue?vue&type=script&lang=ts"

import "./space-list.vue?vue&type=style&index=0&id=4cb02bd2&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb02bd2"]])

export default __exports__